import ToggleOnScriptPng from "./ToggleOnScript.png";

export const ToggleOnScript = () => {
  return (
    <img
      id="toggle-on-script"
      src={ToggleOnScriptPng}
      alt="Toggle On Script"
      draggable="false"
      style={{ height: "100%", width: "auto", objectFit: "contain" }}
    />
  );
};
